import Image, { type ImageLoader } from 'next/image'

type SvgAsset = string | { src: string }

function getSvgSrc(asset: SvgAsset) {
  return typeof asset === 'string' ? asset : asset.src
}

interface BannerAssetProps {
  src: SvgAsset
  alt?: string
}

const passthroughLoader: ImageLoader = ({ src }) => src

export function BannerAsset({ src, alt = '' }: BannerAssetProps) {
  return (
    <Image
      src={getSvgSrc(src)}
      loader={passthroughLoader}
      unoptimized
      width={123}
      height={123}
      alt={alt}
      aria-hidden
    />
  )
}
